import { createSelector } from '@reduxjs/toolkit'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

/** Offering the open status was raised for; `null` where the level states no offering. */
export const selectCockpitSelectedAttentionStatusOffering = createSelector(
  selectFinancialCockpitState,
  ({ selectedAttentionStatusOffering }) => selectedAttentionStatusOffering
)
